import {
  AsyncState,
  loadingAsyncState,
  unloadedAsyncState,
} from 'widgets-for-react'
import { getFooter } from './footerApi'

export type FooterItem = {
  Column: string
  PageId: number
  Title: string
  Url: string
  Weight: number
  LanguageCode: string
}

export type FooterState = {
  menuItems: AsyncState<FooterItem[]>
  subscribeRequest: AsyncState<undefined>
  languageSwitchMode: 'closed' | 'open'
}

export const footerStateUpdaters = {
  updateLanguageMode:
    (newMode: 'closed' | 'open') =>
    (currentState: FooterState): FooterState => ({
      ...currentState,
      languageSwitchMode: newMode,
    }),
}

export const defaultFooterState: FooterState = {
  menuItems: loadingAsyncState(getFooter),
  subscribeRequest: unloadedAsyncState(),
  languageSwitchMode: 'closed',
}
